<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="登录客户编号" prop="userId">
          <el-input v-model="dataForm.userId" placeholder="登录客户编号"></el-input>
      </el-form-item>
          <el-form-item label="账户类型 1连连支付" prop="acctType">
          <el-input v-model="dataForm.acctType" placeholder="账户类型 1连连支付"></el-input>
      </el-form-item>
          <el-form-item label="账户状态 01正常；02停用" prop="acctStatus">
          <el-input v-model="dataForm.acctStatus" placeholder="账户状态 01正常；02停用"></el-input>
      </el-form-item>
          <el-form-item label="客户类别	1:个人;2:平台;3:公司;" prop="custType">
          <el-input v-model="dataForm.custType" placeholder="客户类别	1:个人;2:平台;3:公司;"></el-input>
      </el-form-item>
          <el-form-item label="客户姓名" prop="custName">
          <el-input v-model="dataForm.custName" placeholder="客户姓名"></el-input>
      </el-form-item>
          <el-form-item label="客户证件类型" prop="idType">
          <el-input v-model="dataForm.idType" placeholder="客户证件类型"></el-input>
      </el-form-item>
          <el-form-item label="客户证件号码" prop="idNo">
          <el-input v-model="dataForm.idNo" placeholder="客户证件号码"></el-input>
      </el-form-item>
          <el-form-item label="可用现金" prop="amount">
          <el-input v-model="dataForm.amount" placeholder="可用现金"></el-input>
      </el-form-item>
          <el-form-item label="冻结现金" prop="freezeAmt">
          <el-input v-model="dataForm.freezeAmt" placeholder="冻结现金"></el-input>
      </el-form-item>
          <el-form-item label="红包现金" prop="receivableAmt">
          <el-input v-model="dataForm.receivableAmt" placeholder="红包现金"></el-input>
      </el-form-item>
          <el-form-item label="总金额" prop="totalAmt">
          <el-input v-model="dataForm.totalAmt" placeholder="总金额"></el-input>
      </el-form-item>
          <el-form-item label="资产方Code" prop="platformCode">
          <el-input v-model="dataForm.platformCode" placeholder="资产方Code"></el-input>
      </el-form-item>
          <el-form-item label="第三方类型/资金方Code" prop="thirdType">
          <el-input v-model="dataForm.thirdType" placeholder="第三方类型/资金方Code"></el-input>
      </el-form-item>
          <el-form-item label="第三方账户编号/客户编号" prop="thirdAccount">
          <el-input v-model="dataForm.thirdAccount" placeholder="第三方账户编号/客户编号"></el-input>
      </el-form-item>
          <el-form-item label="存管银行二级电子账户" prop="accountId">
          <el-input v-model="dataForm.accountId" placeholder="存管银行二级电子账户"></el-input>
      </el-form-item>
          <el-form-item label="银行编码" prop="bankCode">
          <el-input v-model="dataForm.bankCode" placeholder="银行编码"></el-input>
      </el-form-item>
          <el-form-item label="银行名称" prop="bankName">
          <el-input v-model="dataForm.bankName" placeholder="银行名称"></el-input>
      </el-form-item>
          <el-form-item label="绑定银行卡号" prop="bankCardNo">
          <el-input v-model="dataForm.bankCardNo" placeholder="绑定银行卡号"></el-input>
      </el-form-item>
          <el-form-item label="银行预留手机号码" prop="mobile">
          <el-input v-model="dataForm.mobile" placeholder="银行预留手机号码"></el-input>
      </el-form-item>
          <el-form-item label="邮箱" prop="email">
          <el-input v-model="dataForm.email" placeholder="邮箱"></el-input>
      </el-form-item>
          <el-form-item label="是否已激活0：未激活；1：已激活" prop="isActivate">
          <el-input v-model="dataForm.isActivate" placeholder="是否已激活0：未激活；1：已激活"></el-input>
      </el-form-item>
          <el-form-item label="是否有交易记录 0否1是" prop="haveRecord">
          <el-input v-model="dataForm.haveRecord" placeholder="是否有交易记录 0否1是"></el-input>
      </el-form-item>
          <el-form-item label="上次提现时间" prop="lastWdDate">
          <el-input v-model="dataForm.lastWdDate" placeholder="上次提现时间"></el-input>
      </el-form-item>
          <el-form-item label="交易时间" prop="tradeDay">
          <el-input v-model="dataForm.tradeDay" placeholder="交易时间"></el-input>
      </el-form-item>
          <el-form-item label="开通授权借款人-授权还款；出借人-授权投标" prop="authorizeOpen">
          <el-input v-model="dataForm.authorizeOpen" placeholder="开通授权借款人-授权还款；出借人-授权投标"></el-input>
      </el-form-item>
          <el-form-item label="授权期限年月日" prop="authorizeDeadline">
          <el-input v-model="dataForm.authorizeDeadline" placeholder="授权期限年月日"></el-input>
      </el-form-item>
          <el-form-item label="授权金额" prop="authorizeAmount">
          <el-input v-model="dataForm.authorizeAmount" placeholder="授权金额"></el-input>
      </el-form-item>
          <el-form-item label="是否已经绑卡1-已绑卡有效  0-卡失效" prop="bindCardStatus">
          <el-input v-model="dataForm.bindCardStatus" placeholder="是否已经绑卡1-已绑卡有效  0-卡失效"></el-input>
      </el-form-item>
          <el-form-item label="实名认证 0:未认证 1：实名认证通过 2：实名认证待审核 -1：实名认证未通过" prop="realNameStatus">
          <el-input v-model="dataForm.realNameStatus" placeholder="实名认证 0:未认证 1：实名认证通过 2：实名认证待审核 -1：实名认证未通过"></el-input>
      </el-form-item>
          <el-form-item label="邮箱认证 0:未认证 1：邮箱认证通过" prop="emailStatus">
          <el-input v-model="dataForm.emailStatus" placeholder="邮箱认证 0:未认证 1：邮箱认证通过"></el-input>
      </el-form-item>
          <el-form-item label="手机认证 -1:未通过,0:未认证,1:通过,2:待审核" prop="mobilePhoneStatus">
          <el-input v-model="dataForm.mobilePhoneStatus" placeholder="手机认证 -1:未通过,0:未认证,1:通过,2:待审核"></el-input>
      </el-form-item>
          <el-form-item label="备用1" prop="spare1">
          <el-input v-model="dataForm.spare1" placeholder="备用1"></el-input>
      </el-form-item>
          <el-form-item label="备用2" prop="spare2">
          <el-input v-model="dataForm.spare2" placeholder="备用2"></el-input>
      </el-form-item>
          <el-form-item label="备用3" prop="spare3">
          <el-input v-model="dataForm.spare3" placeholder="备用3"></el-input>
      </el-form-item>
          <el-form-item label="版本号" prop="version">
          <el-input v-model="dataForm.version" placeholder="版本号"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        userId: '',
        acctType: '',
        acctStatus: '',
        custType: '',
        custName: '',
        idType: '',
        idNo: '',
        amount: '',
        freezeAmt: '',
        receivableAmt: '',
        totalAmt: '',
        platformCode: '',
        thirdType: '',
        thirdAccount: '',
        accountId: '',
        bankCode: '',
        bankName: '',
        bankCardNo: '',
        mobile: '',
        email: '',
        isActivate: '',
        haveRecord: '',
        lastWdDate: '',
        tradeDay: '',
        authorizeOpen: '',
        authorizeDeadline: '',
        authorizeAmount: '',
        bindCardStatus: '',
        realNameStatus: '',
        emailStatus: '',
        mobilePhoneStatus: '',
        spare1: '',
        spare2: '',
        spare3: '',
        createTime: '',
        createBy: '',
        updateTime: '',
        updateBy: '',
        version: '',
        remark: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        userId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        acctType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        acctStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        custType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        custName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        idType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        idNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        amount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        freezeAmt: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        receivableAmt: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalAmt: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        platformCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        thirdType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        thirdAccount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accountId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankCardNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isActivate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        haveRecord: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        lastWdDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        tradeDay: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        authorizeOpen: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        authorizeDeadline: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        authorizeAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bindCardStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        realNameStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        emailStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mobilePhoneStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        spare1: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        spare2: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        spare3: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        version: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/loan/tcustsubaccount/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/loan/tcustsubaccount/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
